import { CreateApiKeyButton } from 'app/domains/api-management';
import { SettingTabsKeys } from '../types';
export function getComponentActions(route) {
    switch (route) {
        case SettingTabsKeys.Api:
            return <CreateApiKeyButton />;
        case SettingTabsKeys.Plan:
        case SettingTabsKeys.Esigning:
        case SettingTabsKeys.Profile:
        default:
            return null;
    }
}
